import { render, staticRenderFns } from "./ChangeTenantDialog.vue?vue&type=template&id=70e5bf74&"
import script from "./ChangeTenantDialog.vue?vue&type=script&lang=js&"
export * from "./ChangeTenantDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports